/* eslint-disable */
export default function init(Blockly, profile, img_path) {
  Blockly.Blocks.blynk = {};
  Blockly.Blocks.blynk.style = "blynk_blocks";
  Blockly.Blocks.blynk.vpins = [
    ["V0", "V0"],
    ["V1", "V1"],
    ["V2", "V2"],
    ["V3", "V3"],
    ["V4", "V4"],
    ["V5", "V5"],
    ["V6", "V6"],
    ["V7", "V7"],
    ["V8", "V8"],
    ["V9", "V9"],
    ["V10", "V10"],
    ["V11", "V11"],
    ["V12", "V12"],
    ["V13", "V13"],
    ["V14", "V14"],
    ["V15", "V15"],
    ["V16", "V16"],
    ["V17", "V17"],
    ["V18", "V18"],
    ["V19", "V19"],
    ["V20", "V20"],
    ["V21", "V21"],
    ["V22", "V22"],
    ["V23", "V23"],
    ["V24", "V24"],
    ["V25", "V25"],
    ["V26", "V26"],
    ["V27", "V27"],
    ["V28", "V28"],
    ["V29", "V29"],
    ["V30", "V30"],
    ["V31", "V31"],
    ["V32", "V32"],
    ["V33", "V33"],
    ["V34", "V34"],
    ["V35", "V35"],
    ["V36", "V36"],
    ["V37", "V37"],
    ["V38", "V38"],
    ["V39", "V39"],
    ["V40", "V40"],
    ["V41", "V41"],
    ["V42", "V42"],
    ["V43", "V43"],
    ["V44", "V44"],
    ["V45", "V45"],
    ["V46", "V46"],
    ["V47", "V47"],
    ["V48", "V48"],
    ["V49", "V49"],
    ["V50", "V50"],
    ["V51", "V51"],
    ["V52", "V52"],
    ["V53", "V53"],
    ["V54", "V54"],
    ["V55", "V55"],
    ["V56", "V56"],
    ["V57", "V57"],
    ["V58", "V58"],
    ["V59", "V59"],
    ["V60", "V60"],
    ["V61", "V61"],
    ["V62", "V62"],
    ["V63", "V63"],
    ["V64", "V64"],
    ["V65", "V65"],
    ["V66", "V66"],
    ["V67", "V67"],
    ["V68", "V68"],
    ["V69", "V69"],
    ["V70", "V70"],
    ["V71", "V71"],
    ["V72", "V72"],
    ["V73", "V73"],
    ["V74", "V74"],
    ["V75", "V75"],
    ["V76", "V76"],
    ["V77", "V77"],
    ["V78", "V78"],
    ["V79", "V79"],
    ["V80", "V80"],
    ["V81", "V81"],
    ["V82", "V82"],
    ["V83", "V83"],
    ["V84", "V84"],
    ["V85", "V85"],
    ["V86", "V86"],
    ["V87", "V87"],
    ["V88", "V88"],
    ["V89", "V89"],
    ["V90", "V90"],
    ["V91", "V91"],
    ["V92", "V92"],
    ["V93", "V93"],
    ["V94", "V94"],
    ["V95", "V95"],
    ["V96", "V96"],
    ["V97", "V97"],
    ["V98", "V98"],
    ["V99", "V99"],
    ["V100", "V100"],
    ["V101", "V101"],
    ["V102", "V102"],
    ["V103", "V103"],
    ["V104", "V104"],
    ["V105", "V105"],
    ["V106", "V106"],
    ["V107", "V107"],
    ["V108", "V108"],
    ["V109", "V109"],
    ["V110", "V110"],
    ["V111", "V111"],
    ["V112", "V112"],
    ["V113", "V113"],
    ["V114", "V114"],
    ["V115", "V115"],
    ["V116", "V116"],
    ["V117", "V117"],
    ["V118", "V118"],
    ["V119", "V119"],
    ["V120", "V120"],
    ["V121", "V121"],
    ["V122", "V122"],
    ["V123", "V123"],
    ["V124", "V124"],
    ["V125", "V125"],
    ["V126", "V126"],
    ["V127", "V127"],
  ];
  Blockly.Blocks.blynk_init_esp01 = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.blynk.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.BLYNK_WIFI)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk.svg", 65, 35)
        )
        .appendField(Blockly.Msg.BLYNK_INIT + " (ESP-01 WiFi)");
      this.appendDummyInput()
        .appendField("Rx")
        .appendField(new Blockly.FieldDropdown(profile["default"].rxtx), "RX")
        .appendField("Tx")
        .appendField(new Blockly.FieldDropdown(profile["default"].rxtx), "TX")
        .appendField(
          new Blockly.FieldDropdown([
            ["2400", "2400"],
            ["4800", "4800"],
            ["9600", "9600"],
            ["19200", "19200"],
            ["38400", "38400"],
            ["57600", "57600"],
            ["115200", "115200"],
          ]),"BAUD").appendField(Blockly.Msg.BLYNK_BAUDRATE);
      this.appendDummyInput()
        .appendField(Blockly.Msg.BLYNK_WIFI_NAME)
        .appendField(new Blockly.FieldTextInput(""), "WIFINAME")
        .appendField(Blockly.Msg.BLYNK_WIFI_PASS)
        .appendField(new Blockly.FieldTextInput(""), "WIFIPASS");
      this.appendDummyInput()
        .appendField(Blockly.Msg.BLYNK_LOCALSERVER)
        .appendField(
          new Blockly.FieldTextInput(
            "0",
            Blockly.FieldTextInput.numberValidator
          ),
          "SERVER1"
        )
        .appendField(".")
        .appendField(
          new Blockly.FieldTextInput(
            "0",
            Blockly.FieldTextInput.numberValidator
          ),
          "SERVER2"
        )
        .appendField(".")
        .appendField(
          new Blockly.FieldTextInput(
            "0",
            Blockly.FieldTextInput.numberValidator
          ),
          "SERVER3"
        )
        .appendField(".")
        .appendField(
          new Blockly.FieldTextInput(
            "0",
            Blockly.FieldTextInput.numberValidator
          ),
          "SERVER4"
        )
        .appendField(Blockly.Msg.BLYNK_LOCALPORT)
        .appendField(
          new Blockly.FieldTextInput(
            "8080",
            Blockly.FieldTextInput.numberValidator
          ),
          "PORT"
        );
      this.appendDummyInput()
        .appendField(Blockly.Msg.BLYNK_AUTH)
        .appendField(new Blockly.FieldTextInput(""), "AUTH");
      this.setInputsInline(!1);
      this.setPreviousStatement(!0, null);
      this.setNextStatement(!0, null);
    },
  };
  Blockly.Blocks.blynk_init_esp8266 = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.blynk.style);
      this.appendDummyInput("")
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk.svg", 65, 35)
        )
        .appendField(Blockly.Msg.BLYNK_INIT);
      this.appendDummyInput()
        .appendField(Blockly.Msg.BLYNK_WIFI_NAME)
        .appendField(new Blockly.FieldTextInput(""), "WIFINAME");
      this.appendDummyInput()
        .appendField(Blockly.Msg.BLYNK_WIFI_PASS)
        .appendField(new Blockly.FieldTextInput(""), "WIFIPASS");
      this.appendDummyInput()
        .appendField(Blockly.Msg.BLYNK_LOCALSERVER)
        .appendField(
          new Blockly.FieldTextInput(
            "0",
            Blockly.FieldTextInput.numberValidator
          ),
          "SERVER1"
        )
        .appendField(".")
        .appendField(
          new Blockly.FieldTextInput(
            "0",
            Blockly.FieldTextInput.numberValidator
          ),
          "SERVER2"
        )
        .appendField(".")
        .appendField(
          new Blockly.FieldTextInput(
            "0",
            Blockly.FieldTextInput.numberValidator
          ),
          "SERVER3"
        )
        .appendField(".")
        .appendField(
          new Blockly.FieldTextInput(
            "0",
            Blockly.FieldTextInput.numberValidator
          ),
          "SERVER4"
        )
        .appendField(Blockly.Msg.BLYNK_LOCALPORT)
        .appendField(
          new Blockly.FieldTextInput(
            "8080",
            Blockly.FieldTextInput.numberValidator
          ),
          "PORT"
        );
      this.appendDummyInput()
        .appendField(Blockly.Msg.BLYNK_AUTH)
        .appendField(new Blockly.FieldTextInput(""), "AUTH");
      this.setInputsInline(!1);
      this.setPreviousStatement(!0, null);
      this.setNextStatement(!0, null);
    },
  };
  Blockly.Blocks.blynk_app_write = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.blynk.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.BLYNK_WIFI)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk.svg", 65, 35)
        )
        .appendField(
          new Blockly.FieldImage(
            img_path + "arduino/blynk_app_write.svg",
            29,
            25
          )
        )
        .appendField(Blockly.Msg.BLYNK_APP_WRITE)
        .appendField(Blockly.Msg.BLYNK_PIN)
        .appendField(
          new Blockly.FieldDropdown(Blockly.Blocks.blynk.vpins),
          "VPIN"
        );
      this.appendStatementInput("DO");
      this.setInputsInline(!1);
      this.setPreviousStatement(!1);
      this.setNextStatement(!1);
    },
  };
  Blockly.Blocks.blynk_app_read = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.blynk.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.BLYNK_WIFI)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk.svg", 65, 35)
        )
        .appendField(
          new Blockly.FieldImage(
            img_path + "arduino/blynk_app_read.svg",
            35,
            35
          )
        )
        .appendField(Blockly.Msg.BLYNK_APP_READ)
        .appendField(Blockly.Msg.BLYNK_PIN)
        .appendField(
          new Blockly.FieldDropdown(Blockly.Blocks.blynk.vpins),
          "VPIN"
        );
      this.appendStatementInput("DO");
      this.setInputsInline(!1);
      this.setPreviousStatement(!1);
      this.setNextStatement(!1);
    },
  };
  Blockly.Blocks.blynk_param_read_int0 = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.blynk.style);
      this.appendDummyInput()
          .appendField(Blockly.Msg.BLYNK_WIFI)

        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk.svg", 65, 35)
        )
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk_read.svg", 35, 35)
        )
        .appendField(Blockly.Msg.BLYNK_PARAM_READ_INT);
      this.setOutput(!0, "Number");
    },
  };
  Blockly.Blocks.blynk_param_read_int = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.blynk.style);
      this.appendDummyInput()
        .appendField(Blockly.Msg.BLYNK_WIFI)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk.svg", 65, 35)
        )
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk_read.svg", 35, 35)
        )
        .appendField(Blockly.Msg.BLYNK_PARAM_READ_INT)
        .appendField(
          new Blockly.FieldDropdown([
            ["-", "-1"],
            ["[0]", "0"],
            ["[1]", "1"],
            ["[2]", "2"],
            ["[3]", "3"],
            ["[4]", "4"],
            ["[5]", "5"],
            ["[6]", "6"],
            ["[7]", "7"],
            ["[8]", "8"],
            ["[9]", "9"],
          ]),
          "INDEX"
        );
      this.setOutput(!0, "Number");
    },
  };
  Blockly.Blocks.blynk_param_read_string0 = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.blynk.style);
      this.appendDummyInput()
        .appendField(Blockly.Msg.BLYNK_WIFI)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk.svg", 65, 35)
        )
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk_read.svg", 35, 35)
        )
        .appendField(Blockly.Msg.BLYNK_PARAM_READ_STRING);
      this.setOutput(!0, "String");
    },
  };
  Blockly.Blocks.blynk_param_read_string = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.blynk.style);
      this.appendDummyInput()
        .appendField(Blockly.Msg.BLYNK_WIFI)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk.svg", 65, 35)
        )
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk_read.svg", 35, 35)
        )
        .appendField(Blockly.Msg.BLYNK_PARAM_READ_STRING)
        .appendField(
          new Blockly.FieldDropdown([
            ["-", "-1"],
            ["[0]", "0"],
            ["[1]", "1"],
            ["[2]", "2"],
            ["[3]", "3"],
            ["[4]", "4"],
            ["[5]", "5"],
            ["[6]", "6"],
            ["[7]", "7"],
            ["[8]", "8"],
            ["[9]", "9"],
          ]),
          "INDEX"
        );
      this.setOutput(!0, "String");
    },
  };
  Blockly.Blocks.blynk_app_connected = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.blynk.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.BLYNK_WIFI)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk.svg", 65, 35)
        )
        .appendField(
          new Blockly.FieldImage(
            img_path + "arduino/blynk_app_connected.svg",
            20,
            25
          )
        )
        .appendField(Blockly.Msg.BLYNK_APP_CONNECTED);
      this.appendStatementInput("DO");
      this.setInputsInline(!1);
      this.setPreviousStatement(!1);
      this.setNextStatement(!1);
    },
  };
  Blockly.Blocks.blynk_app_disconnected = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.blynk.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.BLYNK_WIFI)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk.svg", 65, 35)
        )
        .appendField(
          new Blockly.FieldImage(
            img_path + "arduino/blynk_app_disconnected.svg",
            20,
            25
          )
        )
        .appendField(Blockly.Msg.BLYNK_APP_DISCONNECTED);
      this.appendStatementInput("DO");
      this.setInputsInline(!1);
      this.setPreviousStatement(!1);
      this.setNextStatement(!1);
    },
  };
  Blockly.Blocks.blynk_connected = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.blynk.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.BLYNK_WIFI)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk.svg", 65, 35)
        )
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk_server.svg", 30, 25)
        )
        .appendField(Blockly.Msg.BLYNK_CONNECTED);
      this.appendStatementInput("DO");
      this.setInputsInline(!1);
      this.setPreviousStatement(!1);
      this.setNextStatement(!1);
    },
  };
  Blockly.Blocks.blynk_vpin_write = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.blynk.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.BLYNK_WIFI)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk.svg", 65, 35)
        )
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk_write.svg", 35, 35)
        )
        .appendField(Blockly.Msg.BLYNK_VIRTUALWRITE);
      this.appendDummyInput("").appendField(
        new Blockly.FieldDropdown(Blockly.Blocks.blynk.vpins),
        "VPIN"
      );
      this.appendValueInput("STRINGOUTPUT", "String");
      this.setInputsInline(!0);
      this.setPreviousStatement(!0, null);
      this.setNextStatement(!0, null);
    },
  };
  Blockly.Blocks.blynk_set_property = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.blynk.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.BLYNK_WIFI)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk.svg", 65, 35)
        )
        .appendField(
          new Blockly.FieldImage(
            img_path + "arduino/blynk_property.svg",
            25,
            25
          )
        )
        .appendField(Blockly.Msg.BLYNK_SET_PROPERTY)
        .appendField(Blockly.Msg.BLYNK_PIN);
      this.appendDummyInput("").appendField(
        new Blockly.FieldDropdown(Blockly.Blocks.blynk.vpins),
        "VPIN"
      );
      this.appendValueInput("PROPERTY", "String").appendField(
        Blockly.Msg.BLYNK_PROPERTY
      );
      this.appendValueInput("VALUE", "String").appendField(
        Blockly.Msg.BLYNK_VALUE
      );
      this.setInputsInline(!0);
      this.setPreviousStatement(!0, null);
      this.setNextStatement(!0, null);
    },
  };
  Blockly.Blocks.blynk_led = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.blynk.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.BLYNK_WIFI)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk.svg", 65, 35)
        )
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk_led.svg", 25, 25)
        )
        .appendField(Blockly.Msg.BLYNK_LED)
        .appendField(Blockly.Msg.BLYNK_PIN);
      this.appendDummyInput("").appendField(
        new Blockly.FieldDropdown(Blockly.Blocks.blynk.vpins),
        "VPIN"
      );
      this.appendValueInput("INTENSITY", "Number")
        .setCheck("Number")
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField(Blockly.Msg.BLYNK_LED_INTENSITY);
      this.setInputsInline(!0);
      this.setPreviousStatement(!0, null);
      this.setNextStatement(!0, null);
    },
  };
  Blockly.Blocks.blynk_led_onoff = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.blynk.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.BLYNK_WIFI)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk.svg", 65, 35)
        )
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk_led.svg", 25, 25)
        )
        .appendField(Blockly.Msg.BLYNK_LED)
        .appendField(Blockly.Msg.BLYNK_PIN);
      this.appendDummyInput("").appendField(
        new Blockly.FieldDropdown(Blockly.Blocks.blynk.vpins),
        "VPIN"
      );
      this.appendDummyInput("").appendField(" ");
      this.appendDummyInput("")
          .appendField(Blockly.Msg.ACTUATOR_STATUS)
          .appendField(
            new Blockly.FieldDropdown([
              [Blockly.Msg.BLYNK_BOOLEAN_OFF, "off"],
              [Blockly.Msg.BLYNK_BOOLEAN_ON, "on"],
            ]),
            "STATE");
      this.setInputsInline(!0);
      this.setPreviousStatement(!0, null);
      this.setNextStatement(!0, null);
    },
  };
  Blockly.Blocks.blynk_terminal_print = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.blynk.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.BLYNK_WIFI)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk.svg", 65, 35)
        )
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk_console.svg", 35, 35)
        )
        .appendField(Blockly.Msg.BLYNK_TERMINAL_PRINT);
      this.appendDummyInput("").appendField(
        new Blockly.FieldDropdown(Blockly.Blocks.blynk.vpins),
        "VPIN"
      );
      this.appendValueInput("STRINGOUTPUT", "String");
      this.appendDummyInput("")
        .appendField(new Blockly.FieldCheckbox("TRUE"), "NEWLINE")
        .appendField(Blockly.Msg.BLYNK_ADD_NEW_LINE);
      this.setInputsInline(!0);
      this.setPreviousStatement(!0, null);
      this.setNextStatement(!0, null);
    },
  };
  Blockly.Blocks.blynk_terminal_clear = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.blynk.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.BLYNK_WIFI)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk.svg", 65, 35)
        )
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk_console.svg", 35, 35)
        )
        .appendField(Blockly.Msg.BLYNK_TERMINAL_CLEAR)
        .appendField(
          new Blockly.FieldDropdown(Blockly.Blocks.blynk.vpins),
          "VPIN"
        );
      this.setInputsInline(!0);
      this.setPreviousStatement(!0, null);
      this.setNextStatement(!0, null);
    },
  };
  Blockly.Blocks.blynk_lcd_print = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.blynk.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.BLYNK_WIFI)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk.svg", 65, 35)
        )
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk_lcd.svg", 33, 25)
        )
        .appendField(Blockly.Msg.BLYNK_LCD_PRINT)
        .appendField(
          new Blockly.FieldDropdown(Blockly.Blocks.blynk.vpins),
          "VPIN"
        )
        .appendField(Blockly.Msg.BLYNK_LCD_COL)
        .appendField(
          new Blockly.FieldDropdown([
            ["0", "0"],
            ["1", "1"],
            ["2", "2"],
            ["3", "3"],
            ["4", "4"],
            ["5", "5"],
            ["6", "6"],
            ["7", "7"],
            ["8", "8"],
            ["9", "9"],
            ["10", "10"],
            ["11", "11"],
            ["12", "12"],
            ["13", "13"],
            ["14", "14"],
            ["15", "15"],
          ]),
          "CURSOR_COLUMN"
        )
        .appendField(Blockly.Msg.BLYNK_LCD_ROW)
        .appendField(
          new Blockly.FieldDropdown([
            ["0", "0"],
            ["1", "1"],
          ]),
          "CURSOR_ROW"
        );
      this.appendValueInput("STRINGOUTPUT", "String").setAlign(
        Blockly.ALIGN_RIGHT
      );
      this.setInputsInline(!0);
      this.setPreviousStatement(!0, null);
      this.setNextStatement(!0, null);
    },
  };
  Blockly.Blocks.blynk_map = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.blynk.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.BLYNK_WIFI)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk.svg", 65, 35)
        )
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk_map.svg", 25, 25)
        )
        .appendField(Blockly.Msg.BLYNK_GPS)
        .appendField(
          new Blockly.FieldDropdown(Blockly.Blocks.blynk.vpins),
          "VPIN"
        );
      this.appendDummyInput("")
        .appendField("#")
        .appendField(
          new Blockly.FieldDropdown([
            ["0", "0"],
            ["1", "1"],
            ["2", "2"],
            ["3", "3"],
            ["4", "4"],
            ["5", "5"],
            ["6", "6"],
            ["7", "7"],
            ["8", "8"],
            ["9", "9"],
            ["10", "10"],
            ["11", "11"],
            ["12", "12"],
            ["13", "13"],
            ["14", "14"],
            ["15", "15"],
          ]),
          "INDEX"
        );
      this.appendValueInput("LAT", "Number")
        .setCheck("Number")
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField(Blockly.Msg.BLYNK_GPS_LAT);
      this.appendValueInput("LON", "Number")
        .setCheck("Number")
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField(Blockly.Msg.BLYNK_GPS_LONG);
      this.appendValueInput("DESCRIPTION", "String").setAlign(
        Blockly.ALIGN_RIGHT
      );
      this.setInputsInline(!0);
      this.setPreviousStatement(!0, null);
      this.setNextStatement(!0, null);
    },
  };
  Blockly.Blocks.blynk_lcd_clear = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.blynk.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.BLYNK_WIFI)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk.svg", 65, 35)
        )
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk_lcd.svg", 33, 25)
        )
        .appendField(Blockly.Msg.BLYNK_LCD_CLEAR)
        .appendField(
          new Blockly.FieldDropdown(Blockly.Blocks.blynk.vpins),
          "VPIN"
        );
      this.setInputsInline(!0);
      this.setPreviousStatement(!0, null);
      this.setNextStatement(!0, null);
    },
  };
  Blockly.Blocks.blynk_timer = {
    helpUrl: "",
    shopUrl: "",
    init: function () {
      this.setStyle(Blockly.Blocks.blynk.style);
      this.appendDummyInput("")
        .appendField(Blockly.Msg.BLYNK_WIFI)
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk.svg", 65, 35)
        )
        .appendField(
          new Blockly.FieldImage(img_path + "arduino/blynk_timer.svg", 25, 25)
        )
        .appendField(Blockly.Msg.BLYNK_TIMER)
        .appendField(
          new Blockly.FieldDropdown([
            ["200ms", "200"],
            ["500ms", "500"],
            ["1s", "1000"],
            ["3s", "3000"],
            ["5s", "5000"],
            ["10s", "10000"],
            ["15s", "15000"],
            ["30s", "30000"],
            ["1m", "60000"],
            ["3m", "180000"],
            ["5m", "300000"],
            ["15m", "900000"],
            ["30m", "1800000"],
            ["1h", "3600000"],
          ]),
          "PERIOD"
        );
      this.appendStatementInput("DO");
      this.setInputsInline(!1);
      this.setPreviousStatement(!1);
      this.setNextStatement(!1);
    },
  };
}
